import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const EcommPlayIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M14.2966 4.61204L14.3874 4.66554C16.497 5.90845 18.1383 6.8754 19.3038 7.75828C20.4783 8.64801 21.2957 9.54256 21.5863 10.6875C21.8046 11.5477 21.8046 12.4522 21.5863 13.3124C21.2957 14.4574 20.4783 15.3519 19.3038 16.2417C18.1383 17.1245 16.497 18.0915 14.3874 19.3344L14.2966 19.3879C12.2591 20.5883 10.6713 21.5238 9.38368 22.0918C8.08849 22.6631 6.94501 22.9346 5.84833 22.6123C5.02794 22.3712 4.28435 21.9145 3.68727 21.2897C2.89732 20.4632 2.56682 19.3104 2.40811 17.856C2.24999 16.407 2.24999 14.5026 2.25 12.0493V11.9506C2.24999 9.49729 2.24999 7.59292 2.40811 6.14391C2.56682 4.68953 2.89732 3.53672 3.68727 2.7102C4.28435 2.08547 5.02794 1.62871 5.84833 1.38762C6.94501 1.06534 8.08849 1.33688 9.38368 1.90818C10.6713 2.47611 12.2591 3.41161 14.2966 4.61204ZM8.77832 3.2806C7.57898 2.75158 6.84775 2.65735 6.27125 2.82677C5.70811 2.99225 5.19116 3.30766 4.77165 3.7466C4.33214 4.20645 4.04791 4.94435 3.89926 6.30663C3.75107 7.66458 3.75 9.48699 3.75 12C3.75 14.5129 3.75107 16.3354 3.89926 17.6933C4.04791 19.0556 4.33214 19.7935 4.77165 20.2533C5.19116 20.6923 5.70811 21.0077 6.27125 21.1732C6.84775 21.3426 7.57898 21.2484 8.77832 20.7193C9.97565 20.1912 11.488 19.3016 13.581 18.0685C15.7451 16.7935 17.3104 15.8699 18.398 15.046C19.4848 14.2227 19.9685 13.5892 20.1324 12.9434C20.2892 12.3254 20.2892 11.6746 20.1324 11.0565C19.9685 10.4107 19.4848 9.77725 18.398 8.95394C17.3104 8.13004 15.7451 7.20642 13.581 5.93139C11.488 4.69831 9.97565 3.80873 8.77832 3.2806Z"
            fill="#222"
            fillRule="evenodd"
            clipRule="evenodd"
          />
        </svg>
      </IconWrapper>
    )
  },
)
